module.exports = __webpack_public_path__ + "img/basics5.2ad81acd.png";